export const HEALTH_ORDER: Record<string, number> = { Poor: 0, Fair: 1, Good: 2 };

export const HEALTH_MARKER_COLORS: Record<string, string> = {
    Good: "#157b42",
    Fair: "#a86e00",
    Poor: "#d1252f",
};

export const MAP_CONTAINER_STYLE = { width: "100%", height: "100%" };
export const RIGHT_BOTTOM_CONTROL_POSITION = 9;
export const MONOCHROME_MAP_ID = "cf89b52af1a124cb";
export const DEFAULT_CENTER: google.maps.LatLngLiteral = { lat: -34.397, lng: 150.644 };
export const DEFAULT_ZOOM = 15;